import { useAuth } from "@/context/authContext";
import { useState } from "react";
import type { CreateFormOutput } from "../../forms/rotations/CreateExplorationForm";
import { toast } from "sonner";
import { api } from "@/utils/api";

export const useExplorataions = () => {
  const { dispatch } = useAuth();
  const [loading, setLoading] = useState<{
    loadTeachers: boolean;
    create: boolean;
  }>({ loadTeachers: false, create: false });

  const loadTeachers = async (setTeachers: (teachers: any[]) => void) => {
    try {
      setLoading((prev) => ({ ...prev, loadTeachers: true }));
      const response = await api(
        "/auth/users?shape=teachers",
        { method: "GET" },
        dispatch,
      );
      setTeachers(response.teachers);
    } catch (error: any) {
      toast.error(error.message);
    } finally {
      setLoading((prev) => ({ ...prev, loadTeachers: false }));
    }
  };

  const createExploration = async (
    data: CreateFormOutput,
    onSuccess: () => void,
  ) => {
    try {
      setLoading((prev) => ({ ...prev, create: true }));
      const response = await api(
        "/explorations",
        { method: "POST", body: data },
        dispatch,
      );
      toast.success(response.message);
      onSuccess();
    } catch (error: any) {
      toast.error(error.message);
    } finally {
      setLoading((prev) => ({ ...prev, create: false }));
    }
  };

  return { loadTeachers, createExploration, loading };
};
